import { createSelector } from 'reselect'
import validPairsSelector from './creation_tool_valid_pairs_selector'

export default createSelector(
	[validPairsSelector],
	pairs => pairs.length > 1
)
